(function () {
  const CONTACT_RE = /^\s*CONTACT\s+INFORMATION\s*$/i;

  function normalise(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function isContactInformationPath() {
    return /contact-information/i.test(window.location.pathname || '');
  }

  function findContactTitle() {
    const candidates = [
      '.shopify-policy__title h1',
      '.shopify-policy__title',
      'main h1',
      'main .page-title',
      'main .section-title',
      'main .text-block.h1',
      'main rte-formatter.text-block.h1',
      'main .text-block.custom-typography',
      'main rte-formatter.text-block',
      'main .text-block',
      'main jumbo-text'
    ];

    for (const selector of candidates) {
      for (const element of document.querySelectorAll(selector)) {
        const text = normalise(element.textContent);
        if (CONTACT_RE.test(text)) return element;
      }
    }

    return null;
  }

  function lockContactTitle(element) {
    if (!element || element.dataset.ghostyContactTitleLocked === 'true') return;

    element.dataset.ghostyContactTitleLocked = 'true';
    element.classList.add('ghosty-contact-title-lock');

    // Split into two explicit word-safe lines. This avoids browser differences
    // and Shopify text-block wrappers that can otherwise overflow the card.
    const contactLine = Object.assign(document.createElement('span'), { textContent: 'CONTACT' });
    const informationLine = Object.assign(document.createElement('span'), { textContent: 'INFORMATION' });
    contactLine.className = 'jumbo-text-line';
    informationLine.className = 'jumbo-text-line';
    contactLine.setAttribute('aria-hidden', 'true');
    informationLine.setAttribute('aria-hidden', 'true');
    element.setAttribute('aria-label', 'Contact Information');
    element.replaceChildren(contactLine, informationLine);
  }

  function applyGhostyPolicyFix() {
    const contactTitle = findContactTitle();
    const isContactPage = isContactInformationPath() || Boolean(contactTitle);

    if (isContactPage) {
      document.body.classList.add('ghosty-policy-surface', 'ghosty-contact-information-surface');
      lockContactTitle(contactTitle || findContactTitle());
    }

    if (document.querySelector('.shopify-policy__container') || /\/policies\//i.test(window.location.pathname || '')) {
      document.body.classList.add('ghosty-policy-surface');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGhostyPolicyFix, { once: true });
  } else {
    applyGhostyPolicyFix();
  }

  document.addEventListener('shopify:section:load', applyGhostyPolicyFix);
})();
